/* Ручка лежит поверх внутренней границы панели и не занимает места в потоке. */
.resizer {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 2;
  width: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: col-resize;
  touch-action: none;
}

/* Обе панели режут содержимое по overflow: hidden, поэтому ручка лежит
   целиком внутри и перекрывает последние пиксели панели. */
.onRight {
  right: 0;
}

.onLeft {
  left: 0;
}

/* Полоска проявляется по наведению — в покое граница остаётся тонкой линией панели. */
.grip {
  width: 3px;
  height: 40px;
  border-radius: 999px;
  background: var(--border-strong);
  opacity: 0;
  transition: opacity var(--panel-dur) var(--dnd-ease);
}

.resizer:hover .grip,
.resizer:focus-visible .grip {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .grip {
    transition: none;
  }
}
